export interface RuntimeOptions {
  session_id?: string | null;
}

export function runtimePathPrefix({ session_id }: RuntimeOptions): string {
  if (session_id) {
    return `/runtime/${session_id}`;
  }

  return '';
}
